import React from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import IconSuccess from '../../assets/icons/success-icons.svg'
const NotificationSuccess = () => {
  return (
    <div className="flex items-center flex-col w-8/12  px-8 py-12">
        <img src={IconSuccess} className="w-5/12 mb-6" alt=""/>
        <h3 className="text-xl font-semibold text-font-gray mt-8">Pesanan Berhasil</h3>
        <p className="text-font-gray opacity-75 my-4 max-w-sm text-center">Pesananmu segera dikirim sesuai jadwal terima kasih sudah pesan!</p>
        <Link to="/homepage" className="rounded-lg bg-basic-orange text-white  py-3 px-8"> Kembali Ke Beranda</Link>

    </div>
  )
}

export default NotificationSuccess